import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';
import { isCloudCache } from 'owa-account-source-list-internal';
import { isShadowMailboxUser } from 'owa-session-store';
import { isServiceRequestSupportedForMailbox } from 'owa-service/lib/utils/isServiceRequestSupportedForMailbox';
import { isMailboxSharedOrDelegate } from 'owa-account-shared-mailbox-utils';

export const searchFoldersCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (mailboxInfo) {
            const account = getCoprincipalAccountForMailboxInfo(mailboxInfo);

            return !!(
                account &&
                !isCloudCache(account) &&
                !isShadowMailboxUser(mailboxInfo) &&
                isServiceRequestSupportedForMailbox(mailboxInfo) &&
                !isMailboxSharedOrDelegate(mailboxInfo)
            );
        }

        return false;
    },
};
